import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as fetching } from 'react-redux-fetch-data';
import { reducer as formReducer } from 'redux-form';
import { reducer as uiReducer } from 'redux-ui';
import combinedGlobalReducers from './modules/common/redux/reducers/GlobalReducers';
import combinedSecurityReducers from './modules/security/redux/reducers/index';
import projectReducers from '../reducers';

export default combineReducers({
  fetching,
  routing: routerReducer,
  form: formReducer,
  ui: uiReducer,
  global: combinedGlobalReducers,
  security: combinedSecurityReducers,
  ...projectReducers,
});
